export default __webpack_public_path__ + "static/media/glovein_icon_user.92e52e99.png";